<div *ngIf="showSearchFilter" class="w-full flex flex-row">
  <div class="w-full lg:w-1/2 flex flex-row pb-4">
    <div class="flex w-96">
      <sp-search-field
        [maxWidth]="'384px'"
        (keyUpInput)="searchTextChanged($event)"
        (clearInput)="clearSearch($event)"
        [placeholder]="searchPlaceholder"
        [attrDataTestId]="'search-team'"
      ></sp-search-field>
    </div>
    <sp-custom-table-filter-menu *ngIf="filterObjects.length && showFilterMenu" [filterObjects]="filterObjects" (applyFilter)="applyFilter($event)"></sp-custom-table-filter-menu>
  </div>
</div>

<div class="max-h-[60vh] overflow-auto rounded-t-xl">
  <table mat-table [dataSource]="dataSource" matSort [matSortDisabled]="matSortDisabled" class="table-auto w-full table-bg-color">
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="masterToggle()" [checked]="isAllSelected" [indeterminate]="hasValue() && !isAllSelected" [aria-label]="checkboxLabel()" class="mr-3"> </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="checkBoxToggle(row)" [checked]="row.checked" [aria-label]="checkboxLabel(row)" class="mr-3"> </mat-checkbox>
      </td>
    </ng-container>
    <ng-container *ngFor="let col of tableCols; let colIndex = index" [matColumnDef]="col.columnDef" [stickyEnd]="col.columnDef === 'actions' && colIndex === tableCols.length - 1">
      <!-- Header -->
      <th mat-header-cell *matHeaderCellDef [ngClass]="{ '!text-right': col.columnDef === 'actions' }" class="!font-semibold">
        <span *ngIf="col.columnDef !== 'actions'; else actionsHeader" mat-sort-header>{{ col.header }}</span>
        <ng-template #actionsHeader i18n>Action</ng-template>
      </th>
      <ng-container *ngIf="col.columnDef === 'teamLeaders'">
        <td mat-cell *matCellDef="let rows" class="item-name" spDataTestAttribute [cellValue]="rows.teamLeaders">
          <span *ngIf="rows.teamLeaders; else noLeader">{{ rows.teamLeaders }}</span>
          <ng-template #noLeader>
            <div class="flex items-center">
              <span class="material-icons-outlined text-orange-700">warning_amber</span>&#160;
              <span class="text-orange-700 text-sm" i18n>Team leader missing</span>
            </div>
          </ng-template>
        </td>
      </ng-container>
      <ng-container *ngIf="col.type === TableColumnType.chips">
        <td mat-cell *matCellDef="let tableData; let i = index" class="item-name" spDataTestAttribute [cellValue]="tableData.name">
          <sp-chips-listbox-option [dataSource]="tableData[col.columnDef]" [chipViewMode]="'view'" [chipViewModeClasses]="['!bg-[#f4f4f4]']" class="view-mode"></sp-chips-listbox-option>
        </td>
      </ng-container>
      <ng-container *ngIf="col.type === TableColumnType.tagGroupsEdit">
        <!-- 'rowIndex' is used just for reference purpose, rest of the places it just 'i' -->
        <td mat-cell *matCellDef="let tableData; let rowIndex = index" class="item-name !py-4" spDataTestAttribute [cellValue]="tableData.name">
          <ng-container *ngTemplateOutlet="tagGroupsEdit; context: { $implicit: tableData, rowIndex, colIndex }"></ng-container>
        </td>
      </ng-container>
      <ng-container *ngIf="col.columnDef !== 'actions'">
        <td mat-cell *matCellDef="let tableData; let i = index" [attr.data-test-id]="tableName" [ngClass]="col['class'] ? col['class'] : ''">
          <span *ngIf="!col.showLength && col.type !== 19" [innerHtml]="tableData[col.columnDef] | formatData: col.type"></span>
          <span i18n-matTooltip [matTooltip]="convertHtmlToText(tableData[col.columnDef])" class="html-text" *ngIf="!col.showLength && col.type === 19">{{
            convertHtmlToText(tableData[col.columnDef])
          }}</span>
          <span *ngIf="col.showLength">{{ tableData[col.columnDef].length }}</span>
        </td>
      </ng-container>
      <ng-container *ngIf="col.columnDef === 'actions'">
        <td mat-cell *matCellDef="let tableData; let i = index" class="!text-right" (click)="$event.stopPropagation()">
          <button *ngIf="canDuplicate(tableData)" mat-icon-button i18n-matTooltip matTooltip="Duplicate" (click)="duplicateDialog(i, tableData)" [attr.data-test-id]="'duplicate-action'">
            <mat-icon class="material-icons-outlined">content_copy</mat-icon>
          </button>
          <button *ngIf="canEdit(tableData)" mat-icon-button i18n-matTooltip matTooltip="Edit" (click)="editDialog(tableData)" [attr.data-test-id]="'edit-action'">
            <mat-icon class="material-icons-outlined">edit</mat-icon>
          </button>
          <button
            *ngIf="canDownload(tableData) && !disableDownload"
            mat-icon-button
            i18n-matTooltip
            matTooltip="Download"
            (click)="downloadDialog(i, tableData)"
            [attr.data-test-id]="'download-action'"
          >
            <mat-icon class="material-icons-outlined">file_download</mat-icon>
          </button>
          <button *ngIf="canDelete(tableData)" mat-icon-button i18n-matTooltip matTooltip="Delete" (click)="deleteDialog(i, tableData)" [attr.data-test-id]="'delete-action'">
            <mat-icon class="material-icons-outlined">delete</mat-icon>
          </button>
        </td>
      </ng-container>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="addRowClick && onRowClick(row)" [class.row-click]="addRowClick"></tr>
  </table>
</div>
<mat-paginator [ngClass]="{ '!hidden': !showMatPaginator }" [pageSizeOptions]="[25, 100]" aria-label="Select page..." class="rounded-b-xl"></mat-paginator>
